export default __webpack_public_path__ + "1dccc16e7549cec827db367e7b4ddff8.png";